import { Routes } from '@angular/router';
import processesRoutes from './processes/processes.routes';
import operationsRoutes from './operations/operations.routes';
import workflowsRoutes from './workflows/workflows.routes';
import { PanelComponent } from './panel/panel.component';
import { LayoutComponent } from './core/components/layout/layout.component';
import { LoginComponent } from './authn/pages/login/login.component';
import { privateGuard, publicGuard, RoleGuard, settingsViewGuard } from './core/guards/auth.guard';
import settingsRoutes from './settings/settings.routes';
import identitiesRoutes from './identities/identities.routes';
import reportsRoutes from './reports/reports.routes';
import activityRoutes from './activity/activity.routes';
import { TokenComponent } from './core/components/token/token.component';
import { Permission } from './core/models/role-permissions.models';

export const routes: Routes = [
	{
		path: 'login',
		loadComponent: () => LoginComponent,
		canActivate: [publicGuard],
	},
	{
		path: 'tkn/:tkn',
		loadComponent: () => TokenComponent,
		canActivate: [publicGuard],
	},
	{
		path: '',
		loadComponent: () => LayoutComponent,
		canActivateChild: [privateGuard],
		children: [
			{
				path: 'panel',
				loadComponent: () => PanelComponent,
				canActivate: [RoleGuard],
				data: {
					roles: [Permission.DASHBOARD_VIEW],
					comeback: 'login',
				},
			},
			{
				path: 'processes',
				loadChildren: () => processesRoutes,
				canActivate: [RoleGuard],
				data: {
					roles: [Permission.PROCESS_VIEW],
					comeback: 'panel',
				},
			},
			{
				path: 'operations',
				loadChildren: () => operationsRoutes,
				canActivate: [RoleGuard],
				data: {
					roles: [Permission.OPERATION_VIEW],
					comeback: 'panel',
				},
			},
			{
				path: 'workflows',
				loadChildren: () => workflowsRoutes,
				canActivate: [RoleGuard],
				data: {
					roles: [Permission.WORKFLOW_VIEW],
					comeback: 'panel',
				},
			},
			{
				path: 'identities',
				loadChildren: () => identitiesRoutes,
				canActivate: [RoleGuard],
				data: {
					roles: [Permission.PERSON_VIEW],
					comeback: 'panel',
				},
			},
			{
				path: 'activity',
				loadChildren: () => activityRoutes,
				canActivate: [RoleGuard],
				data: {
					roles: [Permission.ACTIVITY_VIEW],
					comeback: 'panel',
				},
			},
			{
				path: 'developers',
				loadChildren: () => import('./developers/developers.routes').then((m) => m.default),
				canActivate: [RoleGuard],
				data: {
					roles: [Permission.API_KEY_VIEW],
					comeback: 'panel',
				},
			},
			{
				path: 'settings',
				loadChildren: () => settingsRoutes,
				canActivate: [settingsViewGuard],
			},
			{
				path: 'reports',
				loadChildren: () => reportsRoutes,
				canActivate: [RoleGuard],
				data: {
					roles: [Permission.REPORT_VIEW],
					comeback: 'panel',
				},
			},
			{
				path: '**',
				redirectTo: 'panel',
			},
		],
	},
	{
		path: '**',
		redirectTo: '',
	},
];
